import { render, staticRenderFns } from "./addBranchLocation.vue?vue&type=template&id=0dd1ddd8&"
import script from "./addBranchLocation.vue?vue&type=script&lang=js&"
export * from "./addBranchLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports